import { useCampaign } from "@/components/campaign/data";
import { CONSTANTS } from "@/constants";
import { useMemo } from "react";
import { Link, useLocation, useParams } from "react-router-dom";

export function CampaignDetail() {
  const params = useParams();
  const { data } = useCampaign();
  const location = useLocation();

  const campaign = useMemo(() => {
    return data?.data?.find((e) => e.campaignCode == params.id);
  }, [data?.data, params?.id]);

  const backUrl = useMemo(() => {
    const parent = location.pathname.substring(
      0,
      location.pathname.lastIndexOf("/")
    );

    return parent || `/${CONSTANTS.BASE_PATH}/campaign`;
  }, [location?.pathname]);

  return (
    <div className="flex flex-col">
      <div className="flex flex-row gap-4 items-center justify-between px-4 py-5">
        <Link to={backUrl} className="w-6 h-6 cursor-pointer">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M9.293 5.6361L3.636 11.2931C3.44853 11.4806 3.34321 11.7349 3.34321 12.0001C3.34321 12.2653 3.44853 12.5196 3.636 12.7071L9.293 18.3641C9.4816 18.5463 9.7342 18.6471 9.9964 18.6448C10.2586 18.6425 10.5094 18.5373 10.6948 18.3519C10.8802 18.1665 10.9854 17.9157 10.9877 17.6535C10.99 17.3913 10.8892 17.1387 10.707 16.9501L6.757 13.0001H20C20.2652 13.0001 20.5196 12.8947 20.7071 12.7072C20.8946 12.5197 21 12.2653 21 12.0001C21 11.7349 20.8946 11.4805 20.7071 11.293C20.5196 11.1055 20.2652 11.0001 20 11.0001H6.757L10.707 7.0501C10.8025 6.95785 10.8787 6.84751 10.9311 6.7255C10.9835 6.6035 11.0111 6.47228 11.0123 6.3395C11.0134 6.20672 10.9881 6.07504 10.9378 5.95214C10.8875 5.82925 10.8133 5.7176 10.7194 5.6237C10.6255 5.52981 10.5139 5.45556 10.391 5.40528C10.2681 5.355 10.1364 5.32969 10.0036 5.33085C9.87082 5.332 9.7396 5.35959 9.6176 5.412C9.49559 5.46441 9.38525 5.54059 9.293 5.6361Z"
              fill="white"
            />
          </svg>
        </Link>

        <div className="text-white text-xl leading-[1.4]">
          {campaign ? campaign.name : null}
        </div>
        <div className="w-6 h-6 relative"></div>
      </div>

      <div className="flex items-center px-4"></div>
    </div>
  );
}
